import { useEffect, useState } from 'react'

import paymentEvents from '@/utils/gaEvents/paymentEvents'

import type { ShareAbleTime } from '@/api/client/purchase/dto/purchaseDto'
import type { SharedParkinglotDetail } from '@/api/server/detail/dto/detailDto'
import Shared from '@/shared'

import { getShareTicketDailyAbleTime, requestAuthGuest } from '@/api/client/purchase'

export interface SharedPurchaseEnteringTimeViewModel {
  texts: object
  states: {
    enteringTime: ShareAbleTime['usingTime']
    price: ShareAbleTime['price']
    time: ShareAbleTime[]
    selectedIndex: number | null
    isSharedNoticeOpen: boolean
  }
  setters: object
  handlers: {
    handleEnteringTimeValue: (index: number) => void
    handleSharedNoticeOpen: () => void
    onClickTimeNextBtn: () => void
    onClickHeaderBackBtn: () => void
  }
}

const useSharedEnteringTimeViewModel = (data?: SharedParkinglotDetail): SharedPurchaseEnteringTimeViewModel => {
  const setStep = Shared.States.usePurchaseStep((state) => state.setPurchaseStep)
  const { guestSeq } = Shared.States.useStorageStore()

  const [enteringTime, setEnteringTime] = useState<ShareAbleTime['usingTime']>(0)
  const [price, setPrice] = useState<ShareAbleTime['price']>(0)
  const [time, setTime] = useState<ShareAbleTime[]>([])
  const [selectedIndex, setSelectedIndex] = useState<number | null>(null)
  const [isSharedNoticeOpen, setIsSharedNoticeOpen] = useState(false)

  useEffect(() => {
    handleAbleTimes()
  }, [])

  const handleAbleTimes = async () => {
    if (!data) return
    const authPayload = {
      guestSeq: guestSeq
    }
    const { data: auth } = await requestAuthGuest(authPayload)
    const { data: timeData } = await getShareTicketDailyAbleTime({ seq: Number(data.seq) }, auth)
    setTime(
      timeData.times.map((item: ShareAbleTime) => {
        return {
          usingTime: item.usingTime,
          price: item.price
        }
      })
    )
  }

  const handleEnteringTimeValue = (index: number) => {
    if (!time) return
    setSelectedIndex(index)
    setEnteringTime(time[index].usingTime)
    setPrice(time[index].price)
  }

  const handleSharedNoticeOpen = () => {
    if (enteringTime) return
    setIsSharedNoticeOpen((prev) => !prev)
  }

  const onClickTimeNextBtn = () => {
    paymentEvents.shared.onClickNextButton()
    setStep(2)
  }

  const onClickHeaderBackBtn = () => {
    setStep(0)
  }

  return {
    texts: {},
    states: {
      time,
      selectedIndex,
      enteringTime,
      price,
      isSharedNoticeOpen
    },
    setters: {},
    handlers: {
      handleEnteringTimeValue,
      handleSharedNoticeOpen,
      onClickTimeNextBtn,
      onClickHeaderBackBtn
    }
  }
}

export default useSharedEnteringTimeViewModel
